import Vue from 'vue';
import VueRouter from 'vue-router';
import RatingView from '@/views/RatingView.vue';
import FeedbackPositiveView from '@/views/FeedbackPositiveView.vue';
import FeedbackNegativeView from '@/views/FeedbackNegativeView.vue';
import SurveyPageView from '@/views/SurveyPageView.vue';
import SurveyResultsPageView from '@/views/SurveyResultsPageView.vue';
import ReviewView from '@/views/ReviewView.vue';
import ErrorView from '@/views/ErrorView.vue';
import BasicRatingLayout from '@/views/BasicRatingLayout.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: BasicRatingLayout,
      name: 'basic-rating',
      children: [
        {
          path: '/rate/:slug/:type?/:id?',
          name: 'rating',
          component: RatingView,
        },
        {
          path: '/review/:slug',
          name: 'review',
          component: ReviewView,
        },
        {
          path: '/error',
          name: 'error',
          component: ErrorView,
        },
        {
          path: '/positive/:slug',
          name: 'positive',
          component: FeedbackPositiveView,
        },
        {
          path: '/negative/:slug',
          name: 'negative',
          component: FeedbackNegativeView,
        },
      ],
    },
    {
      path: '/survey/:slug/:type?/:id?',
      name: 'survey',
      component: SurveyPageView,
    },
  ],
});

export default router;
